import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../init';
import { DataPoint } from 'src/pages/SignInPage/_BLL/types';

export const useGetDataPoints = (): Record<string, DataPoint> | null => {
	const res = useLiveQuery(() => db.dataPoints.toArray());
	const entries = res?.map(res => [res.name, res.value]);
	return entries ? Object.fromEntries(entries) : null;
};
